import { gql } from '@apollo/client';

const placement = `
  _id
  code
  key
  name
  websiteId
  website {
    _id
    name
  }
  driverTemplateId
  templateSwitchers {
    teasers
    templateId
  }
  publisherId
`

export const CREATE_PLACEMENT = gql`
  mutation Mutation($record: CreatePlacementInput!) {
    PlacementCreateOne(record: $record) {
      ${placement}
    }
  }
`

export const GET_PLACEMENTS = gql`
  query PlacementMany($page: Int, $perPage: Int, $filters: PlacementFilterArgs) {
    placements: PlacementMany(page: $page, perPage: $perPage, filters: $filters) {
      items { 
        ${placement}
      }
      meta {
        totalItems
      }
    }
  }
`

export const GET_ALL_WEBSITES_AND_TEMPLATES = gql`
  query GetAllWebsitesAndTemplates {
    websites: WebsiteMany (perPage: 1000) {
      items {
        value: _id
        label: name
      }
    }
    templates: DriverTemplateMany(perPage: 1000) {
      items {
        value: _id
        label: name
        renderMode
      }
    }
  }
`

export const UPDATE_PLACEMENT = gql`
  mutation Mutation($id: ObjectId!, $record: UpdatePlacementInput!) {
    PlacementUpdateById(_id: $id, record: $record) {
      ${placement}
    }
  }
`
